import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const Pencil02Icon = ({
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    strokeLinejoin = 'round',
    ...props
}: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            stroke={color}
            strokeLinejoin={strokeLinejoin}
            strokeWidth={strokeWidth}
            d="m14.52 5.174 3.192-2.7a2 2 0 0 1 2.706.112l.933.933a2 2 0 0 1 .113 2.706l-2.7 3.191m-9.902 9.598L6.304 20.11a1 1 0 0 1-1.1-.212l-1.165-1.164a1 1 0 0 1-.212-1.101l1.096-2.557a10 10 0 0 1 2.12-3.132l6.417-6.417a2 2 0 0 1 2.829 0l2.12 2.121a2 2 0 0 1 0 2.829l-6.415 6.416a10 10 0 0 1-3.132 2.12ZM2.5 21.437l3.536-1.414L3.914 17.9z"
        />
    </svg>
);
export { Pencil02Icon };
